import React from "react";
import { motion } from "framer-motion";

function About() {
  const services = [
    "CONSULTANCY",
    "SOLAR ENERGY AND INSTALLATIONS",
    "ELECTRONICS",
    "LOGISTICS",
  ];

  const contactInfo = [
    {
      label: "Address",
      value:
        "Saveandbuywithtreacy 1/2A France road by Ibadan road, Salma plaza; sabon gari Kano",
    },
    { label: "Phone", value: "07071033903 or 09160644605" },
    {
      label: "Email",
      value: "saveandbuywithtreacy@gmail.com or save2buywithtreacy@yahoo.com",
    },
  ];

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div
      id="about"
      className="p-4 sm:p-6 mt-[17vh] min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 text-gray-800"
      style={{ scrollMarginTop: "17vh" }}
    >
      <div className="max-w-6xl mx-auto">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8 sm:mb-12 md:mb-16 pt-6 sm:pt-10"
        >
          {/* <div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
              About <span className="text-blue-600">SaveandbuywithTreacy</span>
            </h1>
          </div>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-blue-600 mx-auto rounded-full"></div> */}
          <div className="grid sm:flex items-center justify-center gap-2">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900">
              About
            </h1>
            <span className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-blue-600">
              SaveandbuywithTreacy
            </span>
          </div>
          <div className="w-16 sm:w-20 lg:w-24 h-1 bg-blue-600 mx-auto rounded-full mt-4 sm:mt-6"></div>
        </motion.div>

        {/* Main Content */}
        <motion.div
          variants={staggerContainer}
          initial="initial"
          animate="animate"
          className="space-y-8 sm:space-y-12 md:space-y-16"
        >
          {/* Core Message */}
          <motion.section
            variants={fadeInUp}
            className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 lg:p-12"
          >
            <div className="prose prose-sm sm:prose-base md:prose-lg max-w-none">
              <p className="text-lg sm:text-xl md:text-2xl leading-relaxed text-gray-700 mb-4 sm:mb-6 italic">
                "In a world where promises fade fast, there is a name that still
                stands for integrity, trust and consistency."
              </p>

              <div className="border-l-4 border-blue-600 pl-4 sm:pl-6 py-2 my-4 sm:my-6">
                <p className="text-base sm:text-lg md:text-xl leading-relaxed text-gray-800">
                  At{" "}
                  <strong className="text-blue-600 font-semibold">
                    saveandbuywithTreacy
                  </strong>
                  , we believe that dreams start with small steps. Here you
                  don't have to rush, you save bit by bit at your own pace until
                  what you want becomes what you own. From everyday essentials
                  to life's biggest goals, we sell everything... except human
                  beings.
                </p>
              </div>

              <p className="text-base sm:text-lg md:text-xl leading-relaxed text-gray-800 mb-4 sm:mb-6">
                Because with us every naira, every dollar, every little savings
                brings you closer to the life you've been planning for. This
                isn't just buying, it's believing in something solid. It's
                knowing that your money grows with trust and your dreams grow
                with consistency.
              </p>

              <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-4 sm:p-6 rounded-xl my-6">
                <p className="text-[1.1rem] sm:text-xl md:text-2xl font-bold text-center italic">
                  Saveandbuywithtreacy...pay with ease, grow with peace.
                </p>
              </div>
            </div>
          </motion.section>

          {/* Services Section */}
          <motion.section
            variants={fadeInUp}
            className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 lg:p-12"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6 sm:mb-8 md:mb-10">
              Our <span className="text-blue-600">Services</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.1 + 0.3 }}
                  className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 sm:p-6 rounded-xl border border-blue-200 hover:shadow-lg transition-all duration-300 text-center"
                >
                  <h3 className="text-lg sm:text-xl font-bold text-blue-800 capitalize">
                    {service}
                  </h3>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Contact Information */}
          <motion.section
            variants={fadeInUp}
            className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 lg:p-12"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6 sm:mb-8 md:mb-10">
              Contact <span className="text-blue-600">Us</span>
            </h2>
            <div className="space-y-4 sm:space-y-6">
              {contactInfo.map((contact, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.2 + 0.5 }}
                  className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-3 sm:p-4 bg-blue-50 rounded-lg border border-blue-200"
                >
                  <span className="font-semibold text-blue-800 text-base sm:text-lg md:text-lg min-w-fit mr-4 mb-2 sm:mb-0">
                    {contact.label}:
                  </span>
                  <span className="text-gray-700 text-[0.9rem] sm:text-lg md:text-lg text-left sm:text-right">
                    {contact.value}
                  </span>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Call to Action */}
          <motion.section
            variants={fadeInUp}
            className="text-center py-8 sm:py-10 md:py-12 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl text-white"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">
              Ready to Start Your Journey?
            </h2>
            <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 max-w-full sm:max-w-md md:max-w-xl lg:max-w-2xl mx-auto px-4">
              Join us today and begin saving towards your dreams with trust and
              consistency.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-blue-600 font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg hover:bg-gray-100 transition-colors duration-300 shadow-lg w-full sm:w-auto max-w-xs mx-auto"
            >
              Get Started Today
            </motion.button>
          </motion.section>
        </motion.div>
      </div>
    </div>
  );
}

export default About;
